import React from "react";
import logo from "../assets/icon/logo.png";

function Footer() {
  return (
    <div className="footer-bg">
      <div className="footer">
        <div className="logo">
          <img src={logo} alt="Cartório Nova Veneza" width={250} />
          <div className="line"></div>
        </div>
        <div className="address">
          <p>Cartório Nova Veneza</p>
        </div>
        <div className="rights">
          <p>
            © 2026 - Cartório Nova Veneza | Todos os Direitos Reservados{" "}
          </p>
          <p>
            A product develop by <a href="https://singlec.com.br/">Singlec</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
